(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider {
    constructor(kok) {
      this.kok = kok;
      this.slaytlar = [...kok.querySelectorAll('.hs__slayt')];
      this.noktalar = [...kok.querySelectorAll('[data-hs-nokta]')];
      this.aktif = 0;
      this.sure = parseInt(kok.dataset.hsSure, 10) || 5000;
      this.otomatik =
        kok.dataset.hsOtomatik === '1' &&
        this.slaytlar.length > 1 &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      kok.querySelector('[data-hs-ileri]')?.addEventListener('click', () => this.git(this.aktif + 1, true));
      kok.querySelector('[data-hs-geri]')?.addEventListener('click', () => this.git(this.aktif - 1, true));
      this.noktalar.forEach((n) => n.addEventListener('click', () => this.git(parseInt(n.dataset.hsNokta, 10), true)));

      // Fare/odak uzerindeyken durdur: kullanici okurken slayt kaymasin.
      ['mouseenter', 'focusin'].forEach((o) => kok.addEventListener(o, () => this.dur()));
      ['mouseleave', 'focusout'].forEach((o) => kok.addEventListener(o, () => this.basla()));
      // Sekme arka plandayken sayac islemesin.
      document.addEventListener('visibilitychange', () => (document.hidden ? this.dur() : this.basla()));

      this.basla();
    }

    git(i, elle) {
      const n = this.slaytlar.length;
      const yeni = ((i % n) + n) % n;
      this.slaytlar.forEach((s, j) => {
        if (j === yeni) this.gorseliYukle(s);
        s.classList.toggle('hs__slayt--aktif', j === yeni);
        if (j === yeni) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
      });
      this.noktalar.forEach((d, j) => {
        d.classList.toggle('hs__nokta--aktif', j === yeni);
        d.setAttribute('aria-selected', j === yeni ? 'true' : 'false');
      });
      this.kok.dataset.hsAktif = String(yeni);
      this.aktif = yeni;
      if (elle) this.basla();
    }

    // Aktif olmayan slaytlarin gorseli <template> icinde bekler: opacity:0 ile
    // gizli olsalar da tarayici viewport icinde saydigi icin lazy calismiyordu
    // (olculdu 24.08.2026: mobil ilk yukte 2.4 MB gorsel, LCP 12 sn).
    gorseliYukle(slayt) {
      const kalip = slayt.querySelector('template[data-hs-gorsel]');
      if (!kalip) return;
      kalip.replaceWith(kalip.content.cloneNode(true));
    }

    basla() {
      this.dur();
      if (this.otomatik) this.sayac = setInterval(() => this.git(this.aktif + 1), this.sure);
    }

    dur() {
      if (this.sayac) clearInterval(this.sayac);
      this.sayac = null;
    }
  }

  function heroSliderKur() {
    document.querySelectorAll('[data-hs]').forEach((kok) => {
      if (kok.dataset.hsKurulu === '1') return;
      kok.dataset.hsKurulu = '1';
      new HeroSlider(kok);
    });
  }

  document.addEventListener('DOMContentLoaded', heroSliderKur);
  heroSliderKur();
  // Tema editorunde bolum yeniden yuklendiginde tekrar kur.
  document.addEventListener('shopify:section:load', heroSliderKur);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
